export default __webpack_public_path__ + "static/media/SamsungInterFace-Light.ccd7322a.otf";